export default {
  computed: {
    modeEmbed () {
      return this.$route.query?.mode === "embed"
    },
  },
}
